import { CommonModule } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostListener,
  Inject,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogConfig,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { tap } from 'rxjs';
import { HttpService } from '../../../services/http.service';
import { AUSTRALIA_STATES } from '../../../utils/utils';
import { InputComponent } from '../../from-input/input.component';
import { MultiSelectComponent } from '../../multi-select/multi-select.component';
import { CustomToastComponent } from '../../toast/custom-toast.component';
import { AssignTeacherDialogComponent } from '../add-assign-teacher/assign-teacher-dialog.component';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';

export interface AlertDialogData {
  title?: string;
  message: string;
  submessage: string;
  okText?: string;
  cancelText?: string;
  icon?: string;
  isDeleteLoading?: boolean;
  dialogBgColor?: string;
  okButtonColor?: string;
  cancelButtonColor?: string;
  okButtonTextColor?: string;
  cancelButtonTextColor?: string;
}

interface SchoolType {
  eventTypeId: string;
  eventTypeName: string;
  memberId: string;
  userId: string;
  fullName: string;
  focusAreaId: string;
  focusAreaName: string;
  audienceTypeId: string;
  audienceTypeName: string;
  eventHostRegionName: string;
  eventHostRegionId: string;
  name: string;
  id: string;
  mccEventPartnerId: string;
  mccEventPartnerName: string;
  status?: string;
}

interface SchoolTypeResponse {
  status: boolean;
  message: string;
  data: SchoolType[];
}

interface UploadedImage {
  file: File;
  url: string;
  name: string;
}

interface Step2Payload {
  eventId: string;
  mouSchoolsAttending: boolean;
  nonMouSchoolsAttending: boolean;
  nonMouReason: string;
  schools: Array<{
    schoolId: string;
    teachers: Array<{
      teacherId: string;
    }>;
  }>;
  careerSeekerOrgsOrSportsClubs: string;
  participantsAndSupervisors: string;
  isCsqFunded: boolean | null;
  collaborating: boolean | null;
  collaborationType: number;
  collaboratingWithNonMcc: string;
  mccPartners: Array<{
    mccPartnerId: string;
  }>;
  publishNow: boolean;
  saveAsDraft: any;
}

interface SchoolTeacher {
  userId: string;
  firstName: string;
  lastName: string;
  email: string;
  mobileNumber: string;
  profilePicture: string;
}

interface SchoolData {
  schoolId: string;
  schoolName: string;
  isMou: boolean;
  teachers: SchoolTeacher[];
}

const COLLABORATION_TYPES = {
  MCC_PARTNERS: 1,
  NON_MCC_PARTNERS_ONLY: 2,
  MIXTURE: 3,
} as const;

@Component({
  selector: 'add-event',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    ReactiveFormsModule,
    InputComponent,
    FormsModule,
    MultiSelectComponent,
  ],
  templateUrl: './add-event.component.html',
  styleUrls: ['./add-event.component.scss'],
})
export class AddEventComponent implements OnInit {
  @Input() initialData: any = null;
  @Output() formSubmitted = new EventEmitter<any>();
  fileControl = new FormControl('', Validators.required);
  @ViewChild('mccMultiSelect') mccMultiSelect: any;
  noteText: string = '';
  isSavedAsDraft: boolean = false;
  addressText: string = '';
  focusAreas: any[] = [];
  selectedFocusAreaIds: string[] = [];
  australiaStates = AUSTRALIA_STATES.map((s) => ({ name: s.value, ...s }));
  form!: FormGroup;
  stepTwoForm!: FormGroup;
  isProcessing: boolean = false;
  stepNext: 1 | 2 | 3 = 1;
  isEdit: boolean = false;
  eventTypeOptions: any[] = [];
  eventMangerOptions: any[] = [];
  audienceTypeOptions: any[] = [];
  eventRegionOptions: any[] = [];
  regionOptionsFull: any[] = [];
  mouSchoolOptions: any[] = [];
  nonMouSchoolOptions: any[] = [];
  mouSchools: { school: any; teachers: any[]; showTeachers: boolean }[] = [];
  nonMouSchools: { school: any; teachers: any[]; showTeachers: boolean }[] = [];
  isAddingMou: boolean = false;
  isEditingMouIndex: number = -1;
  isAddingNonMou: boolean = false;
  isEditingNonMouIndex: number = -1;
  isSyncAsana: boolean = false;
  isSyncAsanaFailed: boolean = false;
  createdEventId: string = '';
  collaboratingOptions: any[] = [];
  mccPartnersOptions: any[] = [];
  showMccPartners = false;
  showNonMccPartners = false;
  showCollaborationDetails = false;
  showCareerSeekerField: boolean = false;
  uploadedImages: UploadedImage[] = [];
  isDropdownOpen: boolean = false;
  searchText: string = '';
  filteredSchools: any[] = [];
  isNonMouDropdownOpen: boolean = false;
  nonMouSearchText: string = '';
  filteredNonMouSchools: any[] = [];
  syncLoading: boolean = false;
  currentDateTime = '';
  user = {
    name: '',
  };
  successcall: boolean = false;
  focusAreaError: boolean = false;
  regionHasMouSchools: boolean = true;
  regionHasNonMouSchools: boolean = true;
  isFetchingSchools: boolean = false;
  schoolsFetchCompleted: boolean = false;
  hasNetworkError = false;
  step1SavedAsDraft: boolean = false;
  isPublishing: boolean = false;
  customErrorMessages: any;
  isDraftsubmit: any = '';
  dataSubmitted: boolean = false;
  selectedEventType: any = null;
  yesNoOptions: any[] = [
    { label: 'Yes', value: 'yes' },
    { label: 'No', value: 'no' },
  ];
  storedResponse: any[] = [];
  isDraftProcessing: boolean = false;
  isRegionNotAllow: boolean = false;
  originalRegionId: string | null = null;
  pendingRegionId: string | null = null;
  isRegionChangeConfirmed: boolean = false;
  regionChangedDuringSubmission: boolean = false;
  isTimerequried: boolean = false;
  selectedEventTypeImage: any = '';
  selectedEventTypeDescription: string = '';
  csqUserId: string = '';
  isCsqUser: boolean = false;
  currentUserId: string = '';
  currentUserRole: string = '';
  isBackdatedToggle: boolean = false;
  minDateValue: string | null = null;
  private initialFormValues: any = null;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<AddEventComponent>,
    private httpService: HttpService,
    private snackBar: MatSnackBar,
    private cdRef: ChangeDetectorRef,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA)
    public data: { initialData: any; EditMode: boolean },
  ) {
    this.isEdit = data?.EditMode || false;
    this.initialData = data?.initialData || null;
    this.initializeForms();
    this.initializeUser();
    this.updateCurrentDateTime();
    this.isDraftsubmit = data?.initialData?.eventStatus;
  }

  ngOnInit(): void {
    const userDetailsData = localStorage.getItem('userDetails');
    this.currentUserRole = (localStorage.getItem('userRole') || '').toLowerCase();
    this.isCsqUser = this.currentUserRole === 'csquser';
    this.minDateValue = this.getMinDate();

    if (userDetailsData) {
      const userDetails = JSON.parse(userDetailsData);
      this.currentUserId = userDetails.userId || '';
      this.csqUserId = this.currentUserId;
    }

    this.fetchEventTypes().subscribe();
    this.fetchEventManagers().subscribe();
    this.fetchFocusArea().subscribe();
    this.fetchAudienceTypes().subscribe();
    this.fetchEventRegion().subscribe();
    this.fetchCollaboration().subscribe();
    this.fetchMccPartners().subscribe();

    if (this.isEdit && this.initialData) {
      this.patchFormValues();
    }

    setTimeout(() => {
      this.filteredSchools = [...this.mouSchoolOptions];
      this.filteredNonMouSchools = [...this.nonMouSchoolOptions];
    }, 100);

    this.setupBusRequiredValidation();
  }

  private prefillEventManagerForCurrentUser(): void {
    const userRole = this.currentUserRole;
    const userDetailsData = localStorage.getItem('userDetails');
    const eventManagerControl = this.form.get('eventManager');
    const isCsqRole = ['csquser', 'csqadmin', 'superadmin'].includes(userRole);

    if (
      !isCsqRole ||
      !this.currentUserId ||
      !eventManagerControl ||
      this.isEdit ||
      !!eventManagerControl.value
    ) {
      return;
    }

    setTimeout(() => {
      const matchingManager = this.eventMangerOptions.find(
        (manager) =>
          manager.userId === this.currentUserId ||
          manager.value === this.currentUserId,
      );

      if (matchingManager) {
        this.form.patchValue({
          eventManager: matchingManager.value,
        });

        if (this.isCsqUser) {
          eventManagerControl.disable();
        } else if (eventManagerControl.disabled) {
          eventManagerControl.enable();
        }

        eventManagerControl.updateValueAndValidity();
        this.cdRef.detectChanges();
        return;
      }

      if (this.isCsqUser) {
        const userDetails = userDetailsData ? JSON.parse(userDetailsData) : null;
        if (userDetails) {
          const fullName =
            `${userDetails.firstName || ''} ${userDetails.lastName || ''}`.trim();
          if (fullName) {
            this.eventMangerOptions.unshift({
              label: fullName,
              value: this.currentUserId,
              userId: this.currentUserId,
            });
            this.form.patchValue({
              eventManager: this.currentUserId,
            });
            eventManagerControl.disable();
            eventManagerControl.updateValueAndValidity();
            this.cdRef.detectChanges();
          }
        }
      }
    }, 100);
  }

  private initializeForms(): void {
    this.form = this.fb.group({
      eventName: ['', Validators.required],
      eventDescription: [''],
      eventType: ['', Validators.required],
      eventManager: ['', Validators.required],
      fromDate: ['', Validators.required],
      toDate: ['', Validators.required],
      noOfDays: [''],
      eventTime: ['', [this.timeRangeValidator()]],
      address: ['', [Validators.required, this.noEmptyOrWhitespaceValidator()]],
      audienceType: ['', Validators.required],
      eventRegion: ['', Validators.required],
      cateringRequired: ['', Validators.required],
      busRequired: ['', Validators.required],
      extraRequirements: [''],
    });
    if (this.isCsqUser && this.currentUserId) {
      this.form.get('eventManager')?.disable();
    }
    this.form.get('eventTime')?.valueChanges.subscribe(() => {
      this.validateTimeField();
    });
    this.stepTwoForm = this.fb.group({
      careerSeekerOrganisations: [''],
      approximateParticipants: [
        '',
        [Validators.required, this.noEmptyOrWhitespaceValidator()],
      ],
      preTradeOpportunity: [''],
      collaboratingOrganisations: ['', Validators.required],
      collaboratingWith: [
        '',
        this.conditionalValidator(
          () =>
            this.stepTwoForm?.get('collaboratingOrganisations')?.value ===
            'yes',
        ),
      ],
      mccPartners: [[]],
      nonMccPartners: ['', [this.noEmptyOrWhitespaceValidator()]],
      isMouSchool: [false],
      isNonMouSchool: [false],
    });

    this.stepTwoForm
      .get('collaboratingOrganisations')
      ?.valueChanges.subscribe(() => {
        this.stepTwoForm.get('collaboratingWith')?.updateValueAndValidity();
      });

    this.form.get('audienceType')?.valueChanges.subscribe(() => {
      this.updateCareerSeekerFieldState();
    });

    this.form.get('eventRegion')?.valueChanges.subscribe((regionId) => {
      if (regionId) {
        if (
          this.isEdit &&
          this.originalRegionId === regionId &&
          !this.regionChangedDuringSubmission
        ) {
          return;
        }

        const hasSchoolsSelected =
          this.mouSchools.length > 0 || this.nonMouSchools.length > 0;

        if (
          this.isEdit &&
          hasSchoolsSelected &&
          !this.isRegionChangeConfirmed
        ) {
          this.pendingRegionId = regionId;
          this.showRegionChangeConfirmation();

          setTimeout(() => {
            this.form
              .get('eventRegion')
              ?.setValue(this.originalRegionId, { emitEvent: false });
          });
        } else {
          this.isRegionChangeConfirmed = false;
          this.onRegionSelected(regionId);
        }
      }
    });
    this.storeInitialFormValues();
  }

  validateTimeField(): void {
    const timeControl = this.form.get('eventTime');
    if (timeControl?.invalid) {
      timeControl.markAsTouched();
      this.cdRef.detectChanges();
    }
  }

  private storeInitialFormValues(): void {
    this.initialFormValues = {
      form: this.form.getRawValue(),
      stepTwoForm: this.stepTwoForm.getRawValue(),
      selectedFocusAreaIds: [...this.selectedFocusAreaIds],
      uploadedImages: this.uploadedImages.map((img) => ({
        url: img.url,
        name: img.name,
      })),
      mouSchools: this.mouSchools.map((school) => ({
        school: { ...school.school },
        teachers: school.teachers.map((t) => ({ ...t })),
        showTeachers: school.showTeachers,
      })),
      nonMouSchools: this.nonMouSchools.map((school) => ({
        school: { ...school.school },
        teachers: school.teachers.map((t) => ({ ...t })),
        showTeachers: school.showTeachers,
      })),
      noteText: this.noteText,
      addressText: this.addressText,
    };
  }

  private hasTimeValueChanged(): boolean {
    const currentTime = this.form.get('eventTime')?.value;
    const initialTime = this.initialFormValues?.form?.eventTime;
    if (
      (!currentTime || this.isTimeEmpty(currentTime)) &&
      (!initialTime || this.isTimeEmpty(initialTime))
    ) {
      return false;
    }
    if (
      (!currentTime || this.isTimeEmpty(currentTime)) !==
      (!initialTime || this.isTimeEmpty(initialTime))
    ) {
      return true;
    }

    const currentFrom = currentTime?.from?.trim() || '';
    const currentTo = currentTime?.to?.trim() || '';
    const initialFrom = initialTime?.from?.trim() || '';
    const initialTo = initialTime?.to?.trim() || '';

    return currentFrom !== initialFrom || currentTo !== initialTo;
  }

  private isTimeEmpty(time: any): boolean {
    if (!time) return true;
    if (typeof time === 'object') {
      return (
        (!time.from || time.from.trim() === '') &&
        (!time.to || time.to.trim() === '')
      );
    }
    return !time || time.trim() === '';
  }

  private showRegionChangeConfirmation(): void {
    const dialogData: AlertDialogData = {
      title: 'Change Region',
      message:
        'Changing the region will remove all selected schools and teachers. Do you want to continue?',
      okText: 'Yes',
      cancelText: 'No',
      icon: 'warning',
      submessage: '',
      cancelButtonColor: '#EF4A00',
      okButtonColor: '#2CC3E8',
    };

    const dialogRef = this.dialog.open(AlertDialogComponent, {
      width: '25.438rem',
      data: dialogData,
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.isRegionChangeConfirmed = true;
        this.regionChangedDuringSubmission = true;
        this.originalRegionId = this.pendingRegionId;
        this.form
          .get('eventRegion')
          ?.setValue(this.pendingRegionId, { emitEvent: false });
        this.onRegionSelected(this.pendingRegionId!);
      } else {
        this.isRegionChangeConfirmed = false;
        this.regionChangedDuringSubmission = false;
        this.pendingRegionId = null;
      }
    });
  }

  private noEmptyOrWhitespaceValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (
        control.value === null ||
        control.value === undefined ||
        control.value === ''
      ) {
        return { required: true };
      }
      if (
        typeof control.value === 'string' &&
        control.value.trim().length === 0
      ) {
        return { whitespace: true };
      }

      return null;
    };
  }

  private timeRangeValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;

      if (!value || value === '') {
        return { required: true };
      }

      if (typeof value === 'string') {
        const parts = value.split(' to ');
        if (parts.length !== 2) {
          return { invalidFormat: true };
        }

        const fromTime = parts[0].trim();
        const toTime = parts[1].trim();

        if (!fromTime || fromTime === '') {
          return { missingStart: true };
        }

        if (!toTime || toTime === '') {
          return { missingEnd: true };
        }

        const fromMatch = fromTime.match(/(\d{1,2}):(\d{2})\s*(AM|PM)/i);
        const toMatch = toTime.match(/(\d{1,2}):(\d{2})\s*(AM|PM)/i);

        if (fromMatch && toMatch) {
          const fromHours = this.convertTo24HourForComparison(fromMatch);
          const toHours = this.convertTo24HourForComparison(toMatch);
          if (toHours <= fromHours) {
            return { timeRange: true };
          }
        }
      }

      return null;
    };
  }

  private convertTo24HourForComparison(timeMatch: RegExpMatchArray): number {
    let hours = parseInt(timeMatch[1], 10);
    const minutes = parseInt(timeMatch[2], 10);
    const period = timeMatch[3].toUpperCase();

    if (period === 'PM' && hours < 12) {
      hours += 12;
    } else if (period === 'AM' && hours === 12) {
      hours = 0;
    }

    return hours * 60 + minutes;
  }

  shouldDisableEventType(): boolean {
    const eventNameValue = this.form.get('eventName')?.value;
    return !!eventNameValue && eventNameValue.trim() !== '';
  }

  conditionalValidator(predicate: () => boolean): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (!control.parent) {
        return null;
      }

      if (predicate()) {
        return Validators.required(control);
      }

      return null;
    };
  }

  onEventNameChange(event: any): void {
    const selectedValue = event.value;
    if (selectedValue) {
      const selectedOption = this.eventTypeOptions.find(
        (option) => option.value === selectedValue,
      );
      if (selectedOption) {
        this.selectedEventType = selectedOption;
        this.form.get('eventType')?.setValue(selectedOption.label);
        this.form.get('eventType')?.disable();
        this.selectedEventTypeImage =
          selectedOption.image ||
          '../../../../../assets/images/placeholder-image.svg';
        this.selectedEventTypeDescription =
          selectedOption.imageDescription || '';
      }
    } else {
      this.form.get('eventType')?.setValue('');
      this.form.get('eventType')?.enable();
      this.selectedEventTypeImage = '';
      this.selectedEventTypeDescription = '';
    }
  }

  goStepone(): void {
    this.stepNext = 1;
  }

  private getSelectedAudienceLabel(): string {
    const selectedAudienceId = this.form.get('audienceType')?.value;
    const selectedOption = this.audienceTypeOptions.find(
      (option) => option.value === selectedAudienceId,
    );

    if (selectedOption?.label) {
      return selectedOption.label;
    }

    if (
      this.isEdit &&
      this.initialData?.audienceTypeId === selectedAudienceId &&
      this.initialData?.audienceTypeName
    ) {
      return this.initialData.audienceTypeName;
    }

    return '';
  }

  private shouldShowCareerSeekerField(label: string): boolean {
    const normalizedLabel = label.trim().toLowerCase();

    if (!normalizedLabel) {
      return false;
    }

    return (
      normalizedLabel === 'sports clubs' ||
      normalizedLabel === 'career seekers'
    );
  }

  private updateCareerSeekerFieldState(): void {
    const careerSeekerControl = this.stepTwoForm.get(
      'careerSeekerOrganisations',
    );

    if (!careerSeekerControl) {
      return;
    }

    const shouldShow = this.shouldShowCareerSeekerField(
      this.getSelectedAudienceLabel(),
    );

    this.showCareerSeekerField = shouldShow;

    if (!shouldShow) {
      careerSeekerControl.setValue('', { emitEvent: false });
    }
    careerSeekerControl.clearValidators();
    careerSeekerControl.setErrors(null);

    careerSeekerControl.updateValueAndValidity({ emitEvent: false });
    this.cdRef.detectChanges();
  }

  hasDateFieldError(): any {
    const fromDateControl = this.form.get('fromDate');
    const toDateControl = this.form.get('toDate');
    const fromDateHasError =
      fromDateControl?.invalid &&
      (fromDateControl?.touched || fromDateControl?.dirty);
    const toDateHasError =
      toDateControl?.invalid &&
      (toDateControl?.touched || toDateControl?.dirty);
    return fromDateHasError || toDateHasError;
  }

  private initializeUser(): void {
    const UserDetailsStr = localStorage.getItem('userDetails') || '';
    let name = '';
    try {
      const UserDetails = UserDetailsStr ? JSON.parse(UserDetailsStr) : null;
      if (UserDetails) {
        name =
          (UserDetails.firstName || '') + ' ' + (UserDetails.lastName || '');
      }
    } catch (e) {
      name = '';
    }
    this.user.name = name.trim();
  }

  private updateCurrentDateTime(): void {
    const now = new Date();
    const options: Intl.DateTimeFormatOptions = {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    };
    this.currentDateTime = now.toLocaleDateString('en-US', options);
  }

  private setupBusRequiredValidation(): void {
    const busControl = this.form.get('busRequired');
    const timeControl = this.form.get('eventTime');

    busControl?.valueChanges.subscribe((value) => {
      if (value === 'yes') {
        timeControl?.setValidators([
          Validators.required,
          this.timeRangeValidator(),
        ]);
      } else {
        timeControl?.clearValidators();
        timeControl?.setValidators([this.timeRangeValidator()]);
      }
      timeControl?.updateValueAndValidity();
      this.cdRef.detectChanges();
    });

    if (busControl?.value === 'yes') {
      timeControl?.setValidators([
        Validators.required,
        this.timeRangeValidator(),
      ]);
      timeControl?.updateValueAndValidity();
    }
  }

  onRegionSelected(regionId: string): void {
    if (!regionId) return;

    if (this.regionChangedDuringSubmission || this.isRegionChangeConfirmed) {
      this.originalRegionId = regionId;
    }

    if (
      this.isEdit &&
      this.originalRegionId === regionId &&
      !this.regionChangedDuringSubmission &&
      !this.isRegionChangeConfirmed
    ) {
      return;
    }

    this.isRegionNotAllow = false;
    this.isFetchingSchools = true;
    this.schoolsFetchCompleted = false;
    this.regionHasMouSchools = true;
    this.regionHasNonMouSchools = true;
    this.mouSchoolOptions = [];
    this.nonMouSchoolOptions = [];
    this.mouSchools = [];
    this.nonMouSchools = [];
    this.filteredSchools = [];
    this.filteredNonMouSchools = [];

    this.stepTwoForm.patchValue({
      isMouSchool: false,
      isNonMouSchool: false,
    });

    let mouCompleted = false;
    let nonMouCompleted = false;

    const checkBothCompleted = () => {
      if (mouCompleted && nonMouCompleted) {
        this.schoolsFetchCompleted = true;
        this.isFetchingSchools = false;

        if (this.hasNetworkError) {
          this.cdRef.detectChanges();
          return;
        }

        if (
          this.isEdit &&
          !this.regionChangedDuringSubmission &&
          !this.isRegionChangeConfirmed &&
          this.originalRegionId === regionId
        ) {
          this.prefillSchoolsData();
        }

        if (!this.regionHasMouSchools && !this.regionHasNonMouSchools) {
          this.isRegionNotAllow = true;
          if (this.stepNext !== 2) {
            this.showErrorToast(
              'The selected region does not have any schools available.',
            );
          }
        } else {
          this.isRegionNotAllow = false;
        }

        this.cdRef.detectChanges();
      }
    };

    this.fetchMOUSchools(regionId).subscribe({
      next: () => {
        mouCompleted = true;
        checkBothCompleted();
      },
      error: () => {
        this.regionHasMouSchools = false;
        mouCompleted = true;
        checkBothCompleted();
      },
    });

    this.fetchNONMOUSchools(regionId).subscribe({
      next: () => {
        nonMouCompleted = true;
        checkBothCompleted();
      },
      error: () => {
        this.regionHasNonMouSchools = false;
        nonMouCompleted = true;
        checkBothCompleted();
      },
    });
  }

  onCollaborationChange(event: any): void {
    const selectedValue = event.value;
    this.stepTwoForm.get('mccPartners')?.reset();
    this.stepTwoForm.get('nonMccPartners')?.reset();

    this.stepTwoForm.get('mccPartners')?.clearValidators();
    this.stepTwoForm.get('nonMccPartners')?.clearValidators();

    switch (selectedValue) {
      case COLLABORATION_TYPES.MCC_PARTNERS:
        this.showMccPartners = true;
        this.showNonMccPartners = false;
        this.stepTwoForm
          .get('mccPartners')
          ?.setValidators([Validators.required]);
        break;

      case COLLABORATION_TYPES.NON_MCC_PARTNERS_ONLY:
        this.showMccPartners = false;
        this.showNonMccPartners = true;
        this.stepTwoForm
          .get('nonMccPartners')
          ?.setValidators([Validators.required]);
        break;

      case COLLABORATION_TYPES.MIXTURE:
        this.showMccPartners = true;
        this.showNonMccPartners = true;
        this.stepTwoForm
          .get('mccPartners')
          ?.setValidators([Validators.required]);
        this.stepTwoForm
          .get('nonMccPartners')
          ?.setValidators([Validators.required]);
        break;

      default:
        this.showMccPartners = false;
        this.showNonMccPartners = false;
        break;
    }

    this.stepTwoForm.get('mccPartners')?.updateValueAndValidity();
    this.stepTwoForm.get('nonMccPartners')?.updateValueAndValidity();
  }

  onCollaborationDetailsChange(event: any): void {
    const selectedValue = event.value;
    this.showCollaborationDetails = selectedValue === 'yes';

    const mccPartnersControl = this.stepTwoForm.get('mccPartners');
    const nonMccPartnersControl = this.stepTwoForm.get('nonMccPartners');

    if (selectedValue === 'yes') {
      mccPartnersControl?.setValidators([Validators.required]);
      nonMccPartnersControl?.setValidators([Validators.required]);
    } else {
      this.showMccPartners = false;
      mccPartnersControl?.clearValidators();
      nonMccPartnersControl?.clearValidators();

      mccPartnersControl?.reset();
      nonMccPartnersControl?.reset();
    }

    mccPartnersControl?.updateValueAndValidity();
    nonMccPartnersControl?.updateValueAndValidity();
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const files = Array.from(input.files);
      const validFiles = files.filter(
        (file) =>
          file.type === 'image/png' ||
          file.type === 'image/jpeg' ||
          file.type === 'image/jpg',
      );

      if (validFiles.length !== files.length) {
        this.showErrorToast(
          'Some files were skipped. Only PNG and JPEG images are allowed.',
        );
      }

      validFiles.forEach((file) => {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.uploadedImages.push({
            file: file,
            url: e.target.result,
            name: file.name,
          });
          this.cdRef.detectChanges();
        };
        reader.readAsDataURL(file);
      });
      input.value = '';
    }
  }

  removeImage(index: number): void {
    this.uploadedImages.splice(index, 1);
  }

  onCheckboxChange(event: any, focusArea: any): void {
    this.focusAreaError = false;
    this.cdRef.detectChanges(); // ADD THIS
    const focusAreaId = focusArea.id || focusArea;
    if (event.target.checked) {
      if (!this.selectedFocusAreaIds.includes(focusAreaId)) {
        this.selectedFocusAreaIds.push(focusAreaId);
      }
    } else {
      this.selectedFocusAreaIds = this.selectedFocusAreaIds.filter(
        (id) => id !== focusAreaId,
      );
    }
  }

  private patchFormValues(): void {
    const cateringRequiredValue = this.initialData?.cateringRequired;
    const busRequiredValue = this.initialData?.busRequired;
    let errorValue = '00000000-0000-0000-0000-000000000000';
    let errorDateValue = '0001-01-01T00:00:00';
    if (!this.isCsqUser) {
      this.form.patchValue({
        eventManager: this.initialData?.managers?.[0]?.memberId || '',
      });
    }
    if (
      this.initialData?.eventHostRegionId &&
      this.initialData.eventHostRegionId !== errorValue
    ) {
      this.originalRegionId = this.initialData.eventHostRegionId;
    }
    const eventTimeValue = this.initialData?.eventTime || '';
    let formattedEventTime = eventTimeValue;

    if (
      eventTimeValue &&
      typeof eventTimeValue === 'string' &&
      eventTimeValue.includes('to')
    ) {
      const timePattern =
        /^\d{1,2}:\d{2}\s*(AM|PM)\s+to\s+\d{1,2}:\d{2}\s*(AM|PM)$/i;
      if (!timePattern.test(eventTimeValue)) {
        formattedEventTime = this.convertToDisplayTimeFormat(eventTimeValue);
      }
    }

    const formatDateForInputSimple = (dateString: string) => {
      if (!dateString || dateString === errorDateValue) return '';
      if (dateString.includes('T')) {
        return dateString.split('T')[0];
      }
      return dateString;
    };

    const fromDate = formatDateForInputSimple(this.initialData?.eventStartDate);
    const toDate = formatDateForInputSimple(this.initialData?.eventEndDate);

    if (this.initialData?.createdAt && this.initialData?.eventStartDate) {
      const createdAt = new Date(this.initialData.createdAt);
      const startDate = new Date(this.initialData.eventStartDate);
      this.isBackdatedToggle = startDate < createdAt;
    }

    let eventNameValue = '';
    if (
      this.initialData?.eventTypeName &&
      this.initialData.eventTypeName !== errorValue
    ) {
      const foundOption = this.eventTypeOptions.find(
        (option) => option.label === this.initialData.eventTypeName,
      );

      if (foundOption) {
        eventNameValue = foundOption.value;
      } else if (
        this.initialData?.eventTypeId &&
        this.initialData.eventTypeId !== errorValue
      ) {
        const foundById = this.eventTypeOptions.find(
          (option) => option.value === this.initialData.eventTypeId,
        );
        if (foundById) {
          eventNameValue = foundById.value;
        } else {
          eventNameValue = this.initialData.eventTypeId;
        }
      }
    }

    this.selectedEventTypeImage = this.initialData?.eventTypeImage;
    this.selectedEventTypeDescription =
      this.initialData?.eventTypeImageDescription;

    this.form.patchValue({
      eventName: eventNameValue,
      eventDescription: this.initialData?.description || '',
      eventType: this.initialData?.eventTypeName || '',
      eventManager: this.initialData?.managers?.[0]?.memberId || '',
      fromDate:
        this.initialData?.eventStartDate == errorDateValue
          ? ''
          : this.initialData?.eventStartDate || '',
      toDate:
        this.initialData?.eventEndDate == errorDateValue
          ? ''
          : this.initialData?.eventEndDate || '',
      noOfDays: this.initialData?.noOfDays || '',
      eventTime: formattedEventTime, // Use formatted time here
      address: this.initialData?.location || '',
      audienceType:
        this.initialData?.audienceTypeId == errorValue
          ? null
          : this.initialData?.audienceTypeId || '',
      eventRegion:
        this.initialData?.eventHostRegionId == errorValue
          ? null
          : this.initialData?.eventHostRegionId || '',
      cateringRequired:
        cateringRequiredValue === true
          ? 'yes'
          : cateringRequiredValue === false
            ? 'no'
            : '',
      busRequired:
        busRequiredValue === true
          ? 'yes'
          : busRequiredValue === false
            ? 'no'
            : '',
      extraRequirements: this.initialData?.additionalRequirements || '',
    });

    const preTradeOpportunity = this.initialData?.isCsqFunded;
    const collaboratingOrganisations = this.initialData?.collaborating;
    this.showCollaborationDetails = !!this.initialData?.collaborating;
    this.showMccPartners =
      this.initialData?.collaborationType === 1 ||
      this.initialData?.collaborationType === 3;
    this.showNonMccPartners =
      this.initialData?.collaborationType === 2 ||
      this.initialData?.collaborationType === 3;

    this.stepTwoForm.patchValue({
      careerSeekerOrganisations:
        this.initialData?.careerSeekerOrgsOrSportsClubs || '',
      approximateParticipants:
        this.initialData?.participantsAndSupervisors || '',
      preTradeOpportunity:
        preTradeOpportunity === true
          ? 'yes'
          : preTradeOpportunity === false
            ? 'no'
            : '',
      collaboratingOrganisations:
        collaboratingOrganisations === true
          ? 'yes'
          : collaboratingOrganisations === false
            ? 'no'
            : '',
      collaboratingWith: this.initialData?.collaborationType || '',
      mccPartners:
        this.initialData?.mccPartners?.map(
          (partner: any) => partner.mccEventPartnerId,
        ) || [],
      nonMccPartners: this.initialData?.collaboratingWithNonMcc || '',
      isMouSchool: this.initialData?.mouSchoolsAttending || false,
      isNonMouSchool: this.initialData?.nonMouSchoolsAttending || false,
    });

    if (this.initialData?.focusAreas) {
      this.selectedFocusAreaIds = this.initialData.focusAreas.map(
        (focusArea: any) => focusArea.focusAreaId,
      );
    } else {
      this.selectedFocusAreaIds = [];
    }

    this.noteText = this.initialData?.description || '';
    this.addressText = this.initialData?.location || '';

    if (
      this.initialData?.eventHostRegionId &&
      this.initialData?.eventHostRegionId != errorValue
    ) {
      this.onRegionSelectedForEdit(this.initialData.eventHostRegionId);
    } else {
      setTimeout(() => {
        this.prefillSchoolsData();
      });
    }

    if (
      this.initialData?.eventTypeName &&
      this.initialData.eventTypeName.trim() !== ''
    ) {
      this.form.get('eventType')?.disable();
    }

    if (
      this.initialData?.imagePaths &&
      Array.isArray(this.initialData.imagePaths)
    ) {
      this.loadExistingImages(this.initialData.imagePaths);
    }

    if (this.initialData?.collaboratingWith) {
      this.onCollaborationChange({ value: this.initialData.collaborationType });
    }

    setTimeout(() => {
      if (
        busRequiredValue === true ||
        this.form.get('busRequired')?.value === 'yes'
      ) {
        const timeControl = this.form.get('eventTime');
        timeControl?.setValidators([
          Validators.required,
          this.timeRangeValidator(),
        ]);
        timeControl?.updateValueAndValidity();
      }
      this.updateCareerSeekerFieldState();
      this.storeInitialFormValues();
    });
  }

  private convertToDisplayTimeFormat(timeString: string): string {
    if (!timeString) return '';

    // If it already has AM/PM format, return as is
    if (timeString.includes('AM') || timeString.includes('PM')) {
      return timeString;
    }

    // Check if it's in "HH:MM to HH:MM" format
    if (timeString.includes(' to ')) {
      const [fromPart, toPart] = timeString.split(' to ');
      const fromTime = this.convertTo12HourFormat(fromPart.trim());
      const toTime = this.convertTo12HourFormat(toPart.trim());
      return `${fromTime} to ${toTime}`;
    }

    // Single time value
    if (timeString.includes(':')) {
      return this.convertTo12HourFormat(timeString.trim());
    }

    return timeString;
  }

  private convertTo12HourFormat(timeString: string): string {
    if (!timeString) return '';

    // If already in 12-hour format with AM/PM
    if (timeString.includes('AM') || timeString.includes('PM')) {
      return timeString;
    }

    // Parse 24-hour format
    const [hours, minutes] = timeString.split(':');
    const hourNum = parseInt(hours, 10);

    if (isNaN(hourNum)) return timeString;

    const period = hourNum >= 12 ? 'PM' : 'AM';
    const twelveHour = hourNum % 12 || 12;
    const formattedMinutes = minutes || '00';

    return `${twelveHour}:${formattedMinutes} ${period}`;
  }

  private onRegionSelectedForEdit(regionId: string): void {
    if (!regionId) return;
    this.originalRegionId = regionId;
    this.isFetchingSchools = true;
    this.schoolsFetchCompleted = false;
    this.regionHasMouSchools = true;
    this.regionHasNonMouSchools = true;
    this.mouSchoolOptions = [];
    this.nonMouSchoolOptions = [];
    this.mouSchools = [];
    this.nonMouSchools = [];
    this.filteredSchools = [];
    this.filteredNonMouSchools = [];

    let mouCompleted = false;
    let nonMouCompleted = false;

    const checkBothCompleted = () => {
      if (mouCompleted && nonMouCompleted) {
        this.schoolsFetchCompleted = true;
        this.isFetchingSchools = false;
        this.prefillSchoolsData();
        this.cdRef.detectChanges();
      }
    };

    this.fetchMOUSchools(regionId).subscribe({
      next: () => {
        mouCompleted = true;
        checkBothCompleted();
      },
      error: () => {
        this.hasNetworkError = true;
        this.regionHasMouSchools = false;
        mouCompleted = true;
        checkBothCompleted();
      },
    });

    this.fetchNONMOUSchools(regionId).subscribe({
      next: () => {
        nonMouCompleted = true;
        checkBothCompleted();
      },
      error: () => {
        this.hasNetworkError = true;
        this.regionHasNonMouSchools = false;
        nonMouCompleted = true;
        checkBothCompleted();
      },
    });
  }

  private prefillSchoolsData(): void {
    this.mouSchools = [];
    this.nonMouSchools = [];

    if (this.initialData?.schools && Array.isArray(this.initialData.schools)) {
      this.initialData.schools.forEach((schoolData: SchoolData) => {
        const schoolToFind = {
          value: schoolData.schoolId,
          label: schoolData.schoolName,
        };

        const schoolExistsInOptions = schoolData.isMou
          ? this.mouSchoolOptions.some(
              (option) => option.value === schoolData.schoolId,
            )
          : this.nonMouSchoolOptions.some(
              (option) => option.value === schoolData.schoolId,
            );

        if (!schoolExistsInOptions) {
          const schoolOption = {
            label: schoolData.schoolName,
            value: schoolData.schoolId,
          };

          if (schoolData.isMou) {
            this.mouSchoolOptions.push(schoolOption);
          } else {
            this.nonMouSchoolOptions.push(schoolOption);
          }
        }

        const teacherObjects = schoolData.teachers.map((teacher) => ({
          teacherId: teacher.userId,
          firstName: teacher.firstName,
          lastName: teacher.lastName,
          email: teacher.email,
          mobileNumber: teacher.mobileNumber,
          profilePicture: teacher.profilePicture,
          label: `${teacher.firstName} ${teacher.lastName}`,
          value: teacher.userId,
        }));

        const schoolObject = {
          school: schoolToFind,
          teachers: teacherObjects,
          showTeachers: false,
        };

        if (schoolData.isMou === true) {
          this.mouSchools.push(schoolObject);
        } else {
          this.nonMouSchools.push(schoolObject);
        }
      });

      this.filteredSchools = [...this.mouSchoolOptions];
      this.filteredNonMouSchools = [...this.nonMouSchoolOptions];
    }

    if (this.mouSchools.length > 0) {
      this.stepTwoForm.patchValue({ isMouSchool: true });
    }

    if (this.nonMouSchools.length > 0) {
      this.stepTwoForm.patchValue({ isNonMouSchool: true });
    }

    this.cdRef.detectChanges();
  }

  private parseEventTime(timeString: string): { from: string; to: string } {
    if (!timeString) {
      return { from: '', to: '' };
    }

    if (timeString.includes(' to ')) {
      const [fromPart, toPart] = timeString.split(' to ');
      const fromTime = this.convertTo24HourFormat(fromPart.trim());
      const toTime = this.convertTo24HourFormat(toPart.trim());

      return { from: fromTime, to: toTime };
    }

    return { from: timeString, to: '' };
  }

  private convertTo24HourFormat(timeString: string): string {
    if (!timeString) return '';

    if (/^\d{1,2}:\d{2}$/.test(timeString)) {
      const [hours, minutes] = timeString.split(':');
      return `${hours.padStart(2, '0')}:${minutes}`;
    }

    const timeRegex = /(\d{1,2}):(\d{2})\s*(AM|PM)/i;
    const match = timeString.match(timeRegex);

    if (match) {
      let hours = parseInt(match[1]);
      const minutes = match[2];
      const period = match[3].toUpperCase();

      if (period === 'PM' && hours < 12) {
        hours += 12;
      } else if (period === 'AM' && hours === 12) {
        hours = 0;
      }

      return `${hours.toString().padStart(2, '0')}:${minutes}`;
    }

    return timeString;
  }

  private loadExistingImages(imageUrls: string[]): void {
    this.uploadedImages = imageUrls.map((url) => {
      const fileName = this.extractFileNameFromUrl(url) || 'event-image.jpg';
      return {
        file: this.createFileFromUrl(url, fileName),
        url: url,
        name: fileName,
      };
    });
  }

  private extractFileNameFromUrl(url: string): string {
    try {
      const urlObj = new URL(url);
      const pathname = urlObj.pathname;
      const parts = pathname.split('/');
      const lastPart = parts[parts.length - 1];

      if (lastPart.includes('_')) {
        return lastPart.split('_').pop() || lastPart;
      }

      return lastPart;
    } catch (error) {
      return 'event-image.jpg';
    }
  }

  private createFileFromUrl(url: string, fileName: string): File {
    const blob = new Blob([], { type: 'image/jpeg' });
    return new File([blob], fileName, { type: 'image/jpeg' });
  }

  isFocusAreaSelected(focusAreaId: string): boolean {
    return this.selectedFocusAreaIds.includes(focusAreaId);
  }

  fetchEventTypes() {
    const type = 2;
    return this.httpService
      .get<SchoolTypeResponse>(`eventTypes?status=${type}`)
      .pipe(
        tap({
          next: (response) => {
            if (Array.isArray(response.data)) {
              const excludedEventTypes = [
                'Teacher Work Experience',
                'Teacher Training Workshop',
              ];
              const activeEventTypes = response.data.filter(
                (item: SchoolType) =>
                  item.status === 'Active' &&
                  !excludedEventTypes.includes(item.eventTypeName),
              );
              this.eventTypeOptions = activeEventTypes.map((item: any) => ({
                label: item.eventTypeName,
                value: item.eventTypeId,
                image: item.eventTypeImage || '',
                imageDescription: item.eventTypeImageDescription || '',
              }));

              if (this.isEdit && this.initialData?.eventTypeName) {
                const exists = this.eventTypeOptions.find(
                  (option: { label: any }) =>
                    option.label === this.initialData.eventTypeName,
                );

                if (
                  !exists &&
                  this.initialData.eventTypeName &&
                  this.initialData.eventTypeId
                ) {
                  this.eventTypeOptions.unshift({
                    label: this.initialData.eventTypeName,
                    value: this.initialData.eventTypeId,
                    image: '',
                    imageDescription: '',
                  });
                }
              }
            } else {
              this.showErrorToast('Invalid event type data format');
            }
          },
          error: (err) => {
            this.showErrorToast(err?.message);
          },
        }),
      );
  }

  getSelectedEventTypeLabel(): string {
    const selectedValue = this.form.get('eventName')?.value;
    if (!selectedValue) return '';

    const selectedOption = this.eventTypeOptions.find(
      (option) => option.value === selectedValue,
    );
    return selectedOption ? selectedOption.label : '';
  }

  fetchEventManagers() {
    const type = 2;
    return this.httpService
      .get<SchoolTypeResponse>(`events/event-managers?status=${type}`)
      .pipe(
        tap({
          next: (response) => {
            if (Array.isArray(response.data)) {
              const activeMangers = response.data.filter(
                (item: SchoolType) => item.status === 'Active',
              );

              this.eventMangerOptions = activeMangers.map((item) => ({
                label: item.fullName,
                value: item.memberId,
                userId: item.userId,
              }));
              if (this.isEdit && this.initialData?.managers[0]?.memberId) {
                const exists = this.eventMangerOptions.find(
                  (option: { value: any }) =>
                    option.value === this.initialData?.managers[0]?.memberId,
                );

                if (
                  !exists &&
                  this.initialData?.managers[0]?.firstName &&
                  this.initialData?.managers[0]?.memberId
                ) {
                  this.eventMangerOptions.unshift({
                    label:
                      this.initialData.managers[0]?.firstName +
                      ' ' +
                      this.initialData.managers[0]?.lastName,
                    value: this.initialData.managers[0]?.memberId,
                  });
                }
              }
              this.prefillEventManagerForCurrentUser();
            } else {
              this.showErrorToast('Invalid school type data format');
            }
          },
          error: (err) => {
            this.showErrorToast(err?.message);
          },
        }),
      );
  }

  fetchFocusArea() {
    const type = 2;
    return this.httpService
      .get<SchoolTypeResponse>(`focusareas?status=${type}`)
      .pipe(
        tap({
          next: (response) => {
            if (Array.isArray(response.data)) {
              let activeFocusAreas = response.data.filter(
                (item) => item.status == 'Active',
              );
              this.focusAreas = activeFocusAreas.map((item) => ({
                name: item.focusAreaName,
                id: item.focusAreaId,
              }));

              if (this.isEdit && this.initialData?.focusAreas) {
                this.initialData.focusAreas.forEach(
                  (partner: { focusAreaId: any; focusAreaName: string }) => {
                    if (partner?.focusAreaId) {
                      const existsInActive = this.focusAreas.find(
                        (option: { id: any }) =>
                          option.id === partner.focusAreaId,
                      );
                      const existsInResponse = response.data.find(
                        (item: any) => item.focusAreaId === partner.focusAreaId,
                      );
                      if (!existsInActive && existsInResponse) {
                        this.focusAreas.unshift({
                          name: partner.focusAreaName,
                          id: partner.focusAreaId,
                        });
                      }
                    }
                  },
                );
              }
            } else {
              this.showErrorToast('Invalid school type data format');
            }
          },
          error: (err) => {
            this.showErrorToast(err?.message);
          },
        }),
      );
  }

  fetchAudienceTypes() {
    const type = 2;
    return this.httpService
      .get<SchoolTypeResponse>(`audiencetypes?status=${type}`)
      .pipe(
        tap({
          next: (response) => {
            if (Array.isArray(response.data)) {
              let fliteredAudience = response.data.filter(
                (item) => item.status == 'Active',
              );

              this.audienceTypeOptions = fliteredAudience.map((item) => ({
                label: item.audienceTypeName,
                value: item.audienceTypeId,
              }));
              if (this.isEdit && this.initialData?.audienceTypeId) {
                const exists = this.audienceTypeOptions.find(
                  (option: { value: any }) =>
                    option.value === this.initialData?.audienceTypeId,
                );

                if (
                  !exists &&
                  this.initialData?.audienceTypeName &&
                  this.initialData?.audienceTypeId
                ) {
                  this.audienceTypeOptions.unshift({
                    label: this.initialData.audienceTypeName,
                    value: this.initialData.audienceTypeId,
                  });
                }
              }
              this.updateCareerSeekerFieldState();
            } else {
              this.showErrorToast('Invalid school type data format');
            }
          },
          error: (err) => {
            this.showErrorToast(err?.message);
          },
        }),
      );
  }

  fetchEventRegion() {
    const type = 2;
    return this.httpService
      .get<SchoolTypeResponse>(`eventhostregions?status=${type}`)
      .pipe(
        tap({
          next: (response) => {
            if (Array.isArray(response.data)) {
              const activeRegions = response.data.filter(
                (item: any) => item.status === 'Active',
              );

              this.eventRegionOptions = activeRegions.map((item) => ({
                label: item.eventHostRegionName,
                value: item.eventHostRegionId,
              }));
              if (this.isEdit && this.initialData?.eventHostRegionId) {
                const exists = this.initialData
                  ? this.eventRegionOptions.find(
                      (option: { value: any }) =>
                        option.value === this.initialData.eventHostRegionId,
                    )
                  : undefined;
                if (!exists && this.initialData.eventHostRegionId) {
                  this.eventRegionOptions.unshift({
                    label: this.initialData.eventHostRegionName,
                    value: this.initialData.eventHostRegionId,
                  });
                }
              }
            } else {
              this.eventRegionOptions = [];
              this.showErrorToast('Invalid region data format');
            }
          },
          error: (err) => {
            this.showErrorToast(err?.message);
          },
        }),
      );
  }

  fetchMOUSchools(id: string) {
    return this.httpService
      .get<SchoolTypeResponse>(
        `schools/dropdown?isMouSchool=true&regionid=${id}`,
      )
      .pipe(
        tap({
          next: (response) => {
            if (Array.isArray(response.data)) {
              this.mouSchoolOptions = response.data.map((item) => ({
                label: item.name,
                value: item.id,
              }));
              this.filteredSchools = [...this.mouSchoolOptions];

              this.regionHasMouSchools = this.mouSchoolOptions.length > 0;
            } else {
              this.regionHasMouSchools = false;
            }
          },
          error: () => {
            this.hasNetworkError = true;
            this.regionHasMouSchools = false;
          },
        }),
      );
  }

  fetchNONMOUSchools(id: string) {
    return this.httpService
      .get<SchoolTypeResponse>(
        `schools/dropdown?isMouSchool=false&regionid=${id}`,
      )
      .pipe(
        tap({
          next: (response) => {
            if (Array.isArray(response.data)) {
              this.nonMouSchoolOptions = response.data.map((item) => ({
                label: item.name,
                value: item.id,
              }));
              this.filteredNonMouSchools = [...this.nonMouSchoolOptions];
              this.regionHasNonMouSchools = this.nonMouSchoolOptions.length > 0;
            } else {
              this.regionHasNonMouSchools = false;
            }
          },
          error: () => {
            this.hasNetworkError = true;
            this.regionHasNonMouSchools = false;
          },
        }),
      );
  }

  fetchCollaboration() {
    return this.httpService
      .get<SchoolTypeResponse>('events/collaboration-types')
      .pipe(
        tap({
          next: (response) => {
            if (Array.isArray(response.data)) {
              this.collaboratingOptions = response.data.map((item) => ({
                label: item.name,
                value: item.id,
              }));
            } else {
              this.showErrorToast('Invalid  data format');
            }
          },
          error: (error) => {
            this.showErrorToast(error?.message);
          },
        }),
      );
  }

  fetchMccPartners() {
    const type = 2;
    return this.httpService
      .get<SchoolTypeResponse>(`mcceventpartners?status=${type}`)
      .pipe(
        tap({
          next: (response) => {
            if (Array.isArray(response.data)) {
              let fliteredMcc = response.data.filter(
                (item) => item.status == 'Active',
              );
              this.mccPartnersOptions = fliteredMcc.map((item) => ({
                label: item.mccEventPartnerName,
                value: item.mccEventPartnerId,
              }));
            }
            if (this.isEdit && this.initialData?.mccPartners) {
              this.initialData.mccPartners.forEach(
                (partner: {
                  mccEventPartnerId: any;
                  mccEventPartnerName: string;
                }) => {
                  if (partner?.mccEventPartnerId) {
                    const exists = this.mccPartnersOptions.find(
                      (option: { value: any }) =>
                        option.value === partner.mccEventPartnerId,
                    );

                    if (
                      !exists &&
                      partner?.mccEventPartnerName &&
                      partner?.mccEventPartnerId
                    ) {
                      this.mccPartnersOptions.unshift({
                        label: partner.mccEventPartnerName,
                        value: partner.mccEventPartnerId,
                      });
                    }
                  }
                },
              );
            }
          },
          error: (err) => {
            this.showErrorToast(err?.message);
          },
        }),
      );
  }

  onMouSchoolToggle(): void {
    const isMouSchoolValue = this.stepTwoForm.get('isMouSchool')!.value;

    if (isMouSchoolValue) {
      if (this.mouSchools.length === 0) {
        this.addNewMouSchool();
      }
    } else {
      this.isAddingMou = false;
      this.isEditingMouIndex = -1;
    }
  }

  onNonMouSchoolToggle(): void {
    const isNonMouSchoolValue = this.stepTwoForm.get('isNonMouSchool')!.value;

    if (isNonMouSchoolValue) {
      if (this.nonMouSchools.length === 0) {
        this.addNewNonMouSchool();
      }
    } else {
      this.isAddingNonMou = false;
      this.isEditingNonMouIndex = -1;
    }
  }

  addNewMouSchool(): void {
    this.isAddingMou = true;
    this.isEditingMouIndex = -1;
    this.isAddingNonMou = false;
    this.isEditingNonMouIndex = -1;
  }

  addNewNonMouSchool(): void {
    this.isAddingNonMou = true;
    this.isEditingNonMouIndex = -1;
    this.isAddingMou = false;
    this.isEditingMouIndex = -1;
  }

  syncAsana(): void {
    this.syncLoading = true;
    this.httpService
      .post(`events/${this.createdEventId}/sync-asana`, {})
      .pipe(
        tap({
          next: (res: any) => {
            if (res?.status) {
              this.isSyncAsana = true;
              this.syncLoading = false;
              this.showSuccessToast('Synced with Asana successfully');
            } else {
              this.isSyncAsanaFailed = true;
              this.syncLoading = false;
              this.showErrorToast(
                'Something went wrong. Please try again later.',
              );
            }
          },
          error: (err) => {
            this.showErrorToast(err?.message);
            this.syncLoading = false;
          },
        }),
      )
      .subscribe();
  }

  deleteMouSchool(index: number): void {
    this.mouSchools.splice(index, 1);
  }

  deleteNonMouSchool(index: number): void {
    this.nonMouSchools.splice(index, 1);
  }

  cancelSchoolEdit(): void {
    this.isAddingMou = false;
    this.isEditingMouIndex = -1;
    this.isAddingNonMou = false;
    this.isEditingNonMouIndex = -1;
    this.isDropdownOpen = false;
    this.isNonMouDropdownOpen = false;
    this.searchText = '';
    this.nonMouSearchText = '';
  }

  openDropdown(): void {
    if (!this.regionHasMouSchools) {
      this.showErrorToast('No schools available in the selected region.');
      return;
    }
    this.isDropdownOpen = true;
    this.filterSchools();
  }

  filterSchools(): void {
    if (!this.searchText) {
      this.filteredSchools = [...this.mouSchoolOptions];
    } else {
      const searchLower = this.searchText.toLowerCase();
      this.filteredSchools = this.mouSchoolOptions.filter((school) =>
        this.getSchoolLabel(school).toLowerCase().includes(searchLower),
      );
    }
  }

  filterNonMouSchools(): void {
    if (!this.nonMouSearchText) {
      this.filteredNonMouSchools = [...this.nonMouSchoolOptions];
    } else {
      const searchLower = this.nonMouSearchText.toLowerCase();
      this.filteredNonMouSchools = this.nonMouSchoolOptions.filter((school) =>
        this.getSchoolLabel(school).toLowerCase().includes(searchLower),
      );
    }
  }

  selectSchool(school: any, type: 'mou' | 'nonMou'): void {
    const schoolExists =
      type === 'mou'
        ? this.mouSchools.some((s) => this.compareSchools(s.school, school))
        : this.nonMouSchools.some((s) => this.compareSchools(s.school, school));

    if (!schoolExists) {
      const schoolData = {
        school: school,
        teachers: [],
        showTeachers: false,
      };

      if (type === 'mou') {
        this.mouSchools.push(schoolData);
        this.isDropdownOpen = false;
        this.searchText = '';
      } else {
        this.nonMouSchools.push(schoolData);
        this.isNonMouDropdownOpen = false;
        this.nonMouSearchText = '';
      }
    } else {
      this.showErrorToast('School already selected');
    }

    this.cdRef.detectChanges();
  }

  openNonMouDropdown(): void {
    if (!this.regionHasNonMouSchools) {
      this.showErrorToast(
        'No Non-Partnership School/s available in the selected region.',
      );
      return;
    }
    this.isNonMouDropdownOpen = true;
    this.filterNonMouSchools();
  }

  private compareSchools(school1: any, school2: any): boolean {
    if (typeof school1 === 'object' && typeof school2 === 'object') {
      return school1.value === school2.value;
    }
    return school1 === school2;
  }

  getSchoolLabel(school: any): string {
    if (!school) return '';

    if (typeof school === 'string') {
      const option = this.australiaStates.find((s) => s.value === school);
      return option ? option.label || option.name || school : school;
    }

    if (typeof school === 'object') {
      if (school.label) return school.label;
      if (school.name) return school.name;
      if (school.value) {
        const option = this.australiaStates.find(
          (s) => s.value === school.value,
        );
        return option
          ? option.label || option.name || school.value
          : school.value;
      }
    }

    return String(school);
  }

  getTeacherLabel(teacher: any): string {
    if (!teacher) return '';

    if (typeof teacher === 'string') {
      return teacher;
    }

    if (typeof teacher === 'object') {
      if (teacher.name) return teacher.name;
      if (teacher.label) return teacher.label;
      if (teacher.teacherName) return teacher.teacherName;
      if (teacher.value) return teacher.value;
      if (teacher.firstName && teacher.lastName) {
        return `${teacher.firstName} ${teacher.lastName}`;
      }
    }

    return String(teacher);
  }

  toggleMouTeachers(index: number): void {
    this.mouSchools[index].showTeachers = !this.mouSchools[index].showTeachers;
    this.form.get('fileUpload')?.markAsDirty();
  }

  toggleNonMouTeachers(index: number): void {
    this.nonMouSchools[index].showTeachers =
      !this.nonMouSchools[index].showTeachers;
  }

  removeMouTeacher(schoolIndex: number, teacherIndex: number): void {
    if (
      this.mouSchools[schoolIndex] &&
      this.mouSchools[schoolIndex].teachers[teacherIndex]
    ) {
      this.mouSchools[schoolIndex].teachers.splice(teacherIndex, 1);
      this.showSuccessToast('Teacher removed successfully');
      this.cdRef.detectChanges();
    }
  }

  removeNonMouTeacher(schoolIndex: number, teacherIndex: number): void {
    if (
      this.nonMouSchools[schoolIndex] &&
      this.nonMouSchools[schoolIndex].teachers[teacherIndex]
    ) {
      this.nonMouSchools[schoolIndex].teachers.splice(teacherIndex, 1);
      this.showSuccessToast('Teacher removed successfully');
      this.cdRef.detectChanges();
    }
  }

  openAssignTeacher(
    school: any,
    index: number,
    type: 'mou' | 'nonMou' = 'mou',
    width = '50.5rem',
  ): void {
    let currentTeachers: any[] = [];
    if (type === 'mou' && this.mouSchools[index]) {
      currentTeachers = this.mouSchools[index].teachers;
    } else if (type === 'nonMou' && this.nonMouSchools[index]) {
      currentTeachers = this.nonMouSchools[index].teachers;
    }

    const dialogConfig: MatDialogConfig<any> = {
      width: width,
      maxWidth: '90vw',
      minWidth: '300px',
      data: {
        school: school,
        schoolIndex: index,
        schoolType: type,
        initialData: {
          teachers: currentTeachers,
        },
      },
      disableClose: true,
      autoFocus: false,
      panelClass: 'custom-dialog-container',
    };

    const dialogRef = this.dialog.open(
      AssignTeacherDialogComponent,
      dialogConfig,
    );

    dialogRef.afterClosed().subscribe((result) => {
      if (result?.success) {
        const updatedTeachers = result.teachers || [];

        if (type === 'mou' && this.mouSchools[index]) {
          this.mouSchools[index].teachers = updatedTeachers;
          this.showSuccessToast(
            `Teachers updated for ${this.getSchoolLabel(school)}`,
          );
        } else if (type === 'nonMou' && this.nonMouSchools[index]) {
          this.nonMouSchools[index].teachers = updatedTeachers;
          this.showSuccessToast(
            `Teachers updated for ${this.getSchoolLabel(school)}`,
          );
        }
        this.cdRef.detectChanges();
      }
    });
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (!target.closest('.custom-select-container')) {
      this.isDropdownOpen = false;
      this.isNonMouDropdownOpen = false;
    }
  }

  private validateStepOne(type: any): boolean {
    if (type === 'draft') {
      const eventNameControl = this.form.get('eventName');
      const eventManagerControl = this.form.get('eventManager');
      const audienceTypeControl = this.form.get('audienceType');
      const eventRegionControl = this.form.get('eventRegion');

      [
        eventNameControl,
        eventManagerControl,
        audienceTypeControl,
        eventRegionControl,
      ].forEach((control) => {
        control?.updateValueAndValidity({ emitEvent: false });
        control?.markAsTouched();
      });
      if (this.selectedFocusAreaIds.length === 0) {
        this.focusAreaError = true;
      } else {
        this.focusAreaError = false;
      }
      this.cdRef.detectChanges();

      if (!eventNameControl?.valid) return false;
      if (!eventManagerControl?.disabled && !eventManagerControl?.valid) return false;
      if (!audienceTypeControl?.valid) return false;
      if (this.selectedFocusAreaIds.length === 0) return false;

      return true;
    } else {
      Object.keys(this.form.controls).forEach((key) => {
        const control = this.form.get(key);
        control?.updateValueAndValidity({ emitEvent: false });
        control?.markAsTouched();
      });

      if (this.isRegionNotAllow) {
        this.showErrorToast(
          'The selected region does not have any schools available. Please select a different region.',
        );
        return false;
      }

      if (this.selectedFocusAreaIds.length === 0) {
        this.focusAreaError = true;
        return false;
      }

      const busRequired = this.form.get('busRequired')?.value;
      const eventTimeControl = this.form.get('eventTime');
      const eventTimeValue = eventTimeControl?.value;
      if (busRequired === 'yes') {
        if (!eventTimeValue) {
          eventTimeControl?.setErrors({ required: true });
          eventTimeControl?.markAsTouched();
          this.showErrorToast('Please enter start and end time.');
          return false;
        }

        let from = '';
        let to = '';

        if (typeof eventTimeValue === 'string') {
          if (eventTimeValue.includes(' to ')) {
            const parts = eventTimeValue.split(' to ');
            from = parts[0] || '';
            to = parts[1] || '';
          } else {
            to = eventTimeValue;
          }
        }

        if ((!from || from.trim() === '') && (!to || to.trim() === '')) {
          eventTimeControl?.setErrors({ required: true });
          eventTimeControl?.markAsTouched();
          this.showErrorToast('Please enter start and end time.');
          return false;
        }

        if ((!from || from.trim() === '') && to && to.trim() !== '') {
          eventTimeControl?.setErrors({ missingStart: true });
          eventTimeControl?.markAsTouched();
          this.showErrorToast('Please enter a start time');
          return false;
        }
        if (from && from.trim() !== '' && (!to || to.trim() === '')) {
          eventTimeControl?.setErrors({ missingEnd: true });
          eventTimeControl?.markAsTouched();
          this.showErrorToast('Please enter an end time');
          return false;
        }

        if (
          eventTimeControl?.hasError('required') ||
          eventTimeControl?.hasError('missingStart') ||
          eventTimeControl?.hasError('missingEnd')
        ) {
          eventTimeControl?.setErrors(null);
        }
      } else {
        let from = '';
        let to = '';

        if (typeof eventTimeValue === 'string') {
          if (eventTimeValue.includes(' to ')) {
            const parts = eventTimeValue.split(' to ');
            from = parts[0] || '';
            to = parts[1] || '';
          } else {
            to = eventTimeValue;
          }
        }

        if ((!from || from.trim() === '') && to && to.trim() !== '') {
          eventTimeControl?.setErrors({ missingStart: true });
          eventTimeControl?.markAsTouched();
          this.showErrorToast('Please enter a start time');
          return false;
        }
        if (from && from.trim() !== '' && (!to || to.trim() === '')) {
          eventTimeControl?.setErrors({ missingEnd: true });
          eventTimeControl?.markAsTouched();
          this.showErrorToast('Please enter an end time');
          return false;
        }

        if (
          eventTimeControl?.hasError('required') ||
          eventTimeControl?.hasError('missingStart') ||
          eventTimeControl?.hasError('missingEnd')
        ) {
          eventTimeControl?.setErrors(null);
        }
      }

      return this.form.valid;
    }
  }

  private validateStepOneForPublish(): boolean {
    if (this.isRegionNotAllow) {
      this.showErrorToast(
        'The selected region does not have any schools available. Please select a different region.',
      );
      return false;
    }

    if (!this.form.valid) {
      return false;
    }

    if (this.selectedFocusAreaIds.length === 0) {
      this.focusAreaError = true;
      return false;
    }

    return true;
  }

  private validateSchoolsForPublish(): string | null {
    const hasAtLeastOneSchool =
      this.mouSchools.length > 0 || this.nonMouSchools.length > 0;

    if (!hasAtLeastOneSchool) {
      return 'Please select at least one school before publishing.';
    }

    for (const school of this.mouSchools) {
      if (!school.teachers || school.teachers.length === 0) {
        return `Please select at least one teacher for ${this.getSchoolLabel(school.school)}`;
      }
    }

    for (const school of this.nonMouSchools) {
      if (!school.teachers || school.teachers.length === 0) {
        return `Please select at least one teacher for ${this.getSchoolLabel(school.school)}`;
      }
    }

    return null;
  }

  private validateStepTwo(type: any): boolean {
    if (type !== 'draft') {
      this.isSavedAsDraft = false;
      Object.keys(this.stepTwoForm.controls).forEach((key) => {
        this.stepTwoForm.get(key)?.markAsTouched();
      });

      if (this.mccMultiSelect) {
        this.mccMultiSelect.markAsSubmitted();
      }


      const approximateParticipants = this.stepTwoForm.get(
        'approximateParticipants',
      );
      if (
        !approximateParticipants?.value ||
        approximateParticipants.value.trim() === ''
      ) {
        approximateParticipants?.setErrors({ required: true });
        return false;
      }

      // const preTradeOpportunity = this.stepTwoForm.get('preTradeOpportunity');
      // if (!preTradeOpportunity?.value || preTradeOpportunity.value === '') {
      //     preTradeOpportunity?.setErrors({ required: true });
      //     return false;
      // }

      const collaboratingOrganisations = this.stepTwoForm.get(
        'collaboratingOrganisations',
      );
      if (
        !collaboratingOrganisations?.value ||
        collaboratingOrganisations.value === ''
      ) {
        collaboratingOrganisations?.setErrors({ required: true });
        return false;
      }

      const collaboratingWith =
        this.stepTwoForm.get('collaboratingWith')?.value;
      const collaboratingValue = collaboratingOrganisations?.value;

      if (collaboratingValue === 'yes') {
        if (!collaboratingWith) {
          const collaboratingWithControl =
            this.stepTwoForm.get('collaboratingWith');
          collaboratingWithControl?.setErrors({ required: true });
          return false;
        }

        if (this.showMccPartners) {
          const mccPartnersValue = this.stepTwoForm.get('mccPartners')?.value;
          const isEmpty =
            !mccPartnersValue ||
            (Array.isArray(mccPartnersValue) &&
              mccPartnersValue.length === 0) ||
            (typeof mccPartnersValue === 'object' &&
              Object.keys(mccPartnersValue).length === 0);

          if (isEmpty) {
            const mccControl = this.stepTwoForm.get('mccPartners');
            mccControl?.markAsTouched();
            mccControl?.setErrors({ required: true });
            this.showErrorToast('Please select at least one MCC partner');
            this.cdRef.detectChanges();
            return false;
          }
        }

        if (this.showNonMccPartners) {
          const nonMccValue = this.stepTwoForm.get('nonMccPartners')?.value;
          if (!nonMccValue || nonMccValue.trim() === '') {
            const nonMccControl = this.stepTwoForm.get('nonMccPartners');
            nonMccControl?.markAsTouched();
            nonMccControl?.setErrors({ required: true });
            this.showErrorToast('Please enter non-MCC partner details');
            return false;
          }
        }
      }

    }

    return true;
  }

  onSubmit(type?: string, close?: boolean): void {
    if (this.isProcessing || this.isDraftProcessing) return;
    if (this.mccMultiSelect) {
      this.mccMultiSelect.markAsSubmitted();
    }
    if (type === 'draft') {
      this.isDraftProcessing = true;
    } else {
      this.isProcessing = true;
    }

    if (this.stepNext === 1) {
      if (type !== 'draft') {
        if (this.isRegionNotAllow) {
          this.resetProcessingFlags(type);
          this.showErrorToast(
            'The selected region does not have any schools available. Please select a different region.',
          );
          return;
        }
      }

      if (!this.validateStepOne(type)) {
        this.resetProcessingFlags(type);
        return;
      }

      this.submitStepOne(type, close);
    } else if (this.stepNext === 2) {
      if (type !== 'draft') {
        if (this.isRegionNotAllow) {
          this.resetProcessingFlags(type);
          this.showErrorToast(
            'The selected region does not have any schools available. Please go back and select a different region.',
          );
          this.stepNext = 1;
          return;
        }
      }

      if (!type) {
        if (!this.validateStepOneForPublish()) {
          this.resetProcessingFlags(type);
          this.showStep1ValidationAlert(false);
          return;
        }

        const schoolError = this.validateSchoolsForPublish();
        if (schoolError) {
          this.resetProcessingFlags(type);
          this.showStep1ValidationAlert(false, schoolError);
          return;
        }
      }

      if (!type && !this.validateTimeFieldsForStep2()) {
        this.resetProcessingFlags(type);
        this.showStep1ValidationAlert(true);
        return;
      }

      if (!this.validateStepTwo(type)) {
        this.resetProcessingFlags(type);
        return;
      }
      this.submitStepTwo(type);
    }
  }

  private validateTimeFieldsForStep2(): boolean {
    const busRequired = this.form.get('busRequired')?.value;
    const eventTimeControl = this.form.get('eventTime');
    const eventTimeValue = eventTimeControl?.value;

    let from = '';
    let to = '';

    if (eventTimeValue) {
      if (typeof eventTimeValue === 'object' && eventTimeValue !== null) {
        from = this.convertTo24HourFormat((eventTimeValue.from || '').trim());
        to = this.convertTo24HourFormat((eventTimeValue.to || '').trim());
      } else if (typeof eventTimeValue === 'string') {
        if (eventTimeValue.includes(' to ')) {
          const parts = eventTimeValue.split(' to ');
          from = this.convertTo24HourFormat((parts[0] || '').trim());
          to = this.convertTo24HourFormat((parts[1] || '').trim());
        } else {
          from = this.convertTo24HourFormat(eventTimeValue.trim());
        }
      }
    }

    const hasFromValue = from !== '';
    const hasToValue = to !== '';
    const timeRegex = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/;

    if (busRequired === 'yes') {
      if (!hasFromValue || !hasToValue) {
        return false;
      }
      if (!timeRegex.test(from) || !timeRegex.test(to)) {
        return false;
      }
      const fromDate = new Date(`2000-01-01T${from}`);
      const toDate = new Date(`2000-01-01T${to}`);
      if (toDate <= fromDate) {
        return false;
      }
    } else {
      if (hasFromValue || hasToValue) {
        if (hasFromValue && hasToValue) {
          if (!timeRegex.test(from) || !timeRegex.test(to)) {
            return false;
          }
          const fromDate = new Date(`2000-01-01T${from}`);
          const toDate = new Date(`2000-01-01T${to}`);
          if (toDate <= fromDate) {
            return false;
          }
        } else {
          return false;
        }
      }
    }

    return true;
  }

  private resetProcessingFlags(type?: string): void {
    if (type === 'draft') {
      this.isDraftProcessing = false;
    } else {
      this.isProcessing = false;
    }
  }

  private showStep1ValidationAlert(type: boolean, customMessage?: string): void {
    this.isTimerequried = type;
    const dialogData: AlertDialogData = {
      title: '',
      message: customMessage ?? (type
        ? 'Please make sure you selected the required times in Step 1 and Step 2 before publishing.'
        : 'Please complete all required fields in Step 1 and then Step 2 before publishing.'),
      okText: 'Go to Step 1',
      cancelText: 'Cancel',
      icon: 'warning',
      submessage: '',
      cancelButtonColor: '#EF4A00',
      okButtonColor: '#2CC3E8',
    };

    const dialogRef = this.dialog.open(AlertDialogComponent, {
      width: '25.438rem',
      data: dialogData,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.stepNext = 1;
        Object.keys(this.form.controls).forEach((key) => {
          const control = this.form.get(key);
          control?.markAsTouched();
        });

        if (this.isTimerequried) {
          this.markTimeFieldErrors();
        }

        this.cdRef.detectChanges();
      }
    });
  }

  private markTimeFieldErrors(): void {
    const busRequired = this.form.get('busRequired')?.value;
    const eventTimeControl = this.form.get('eventTime');
    const eventTimeValue = eventTimeControl?.value;

    let from = '';
    let to = '';

    if (eventTimeValue) {
      if (typeof eventTimeValue === 'object' && eventTimeValue !== null) {
        from = this.convertTo24HourFormat((eventTimeValue.from || '').trim());
        to = this.convertTo24HourFormat((eventTimeValue.to || '').trim());
      } else if (typeof eventTimeValue === 'string') {
        if (eventTimeValue.includes(' to ')) {
          const parts = eventTimeValue.split(' to ');
          from = this.convertTo24HourFormat((parts[0] || '').trim());
          to = this.convertTo24HourFormat((parts[1] || '').trim());
        } else {
          to = this.convertTo24HourFormat(eventTimeValue.trim());
        }
      }
    }

    const hasFrom = from !== '';
    const hasTo = to !== '';
    const timeRegex = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/;

    const checkRange = (f: string, t: string): boolean => {
      if (!timeRegex.test(f) || !timeRegex.test(t)) return false;
      return new Date(`2000-01-01T${t}`) > new Date(`2000-01-01T${f}`);
    };

    if (busRequired === 'yes') {
      if (!hasFrom && !hasTo) {
        eventTimeControl?.setErrors({ required: true });
        eventTimeControl?.markAsTouched();
        this.showErrorToast('Please enter start and end time.');
      } else if (!hasFrom && hasTo) {
        eventTimeControl?.setErrors({ missingStart: true });
        eventTimeControl?.markAsTouched();
        this.showErrorToast('Please enter a start time');
      } else if (hasFrom && !hasTo) {
        eventTimeControl?.setErrors({ missingEnd: true });
        eventTimeControl?.markAsTouched();
        this.showErrorToast('Please enter an end time');
      } else {
        if (!checkRange(from, to)) {
          eventTimeControl?.setErrors({ timeRange: true });
          eventTimeControl?.markAsTouched();
          this.showErrorToast('End time must be after start time');
        }
      }
    } else {
      if (!hasFrom && hasTo) {
        eventTimeControl?.setErrors({ missingStart: true });
        eventTimeControl?.markAsTouched();
        this.showErrorToast('Please enter a start time');
      } else if (hasFrom && !hasTo) {
        eventTimeControl?.setErrors({ missingEnd: true });
        eventTimeControl?.markAsTouched();
        this.showErrorToast('Please enter an end time');
      } else if (hasFrom && hasTo) {
        if (!checkRange(from, to)) {
          eventTimeControl?.setErrors({ timeRange: true });
          eventTimeControl?.markAsTouched();
          this.showErrorToast('End time must be after start time');
        }
      }
    }
  }

  onMccPartnersChange(selectedPartnerIds: string[]): void {
    this.stepTwoForm.patchValue({
      mccPartners: selectedPartnerIds,
    });

    const mccControl = this.stepTwoForm.get('mccPartners');
    if (selectedPartnerIds && selectedPartnerIds.length > 0) {
      mccControl?.setErrors(null);
    }
    mccControl?.updateValueAndValidity();
    this.cdRef.detectChanges();
  }

  private getSelectedSchoolsPayload(): Array<{
    schoolId: string;
    teachers: Array<{ teacherId: string }>;
  }> {
    const allSchools: Array<{
      schoolId: string;
      teachers: Array<{ teacherId: string }>;
    }> = [];

    if (this.stepTwoForm.get('isMouSchool')?.value) {
      allSchools.push(
        ...this.mouSchools.map((school) => ({
          schoolId: school.school.value || school.school,
          teachers: school.teachers
            .map((teacher) => ({
              teacherId: this.extractTeacherId(teacher),
            }))
            .filter((teacher) => !!teacher.teacherId),
        })),
      );
    }

    if (this.stepTwoForm.get('isNonMouSchool')?.value) {
      allSchools.push(
        ...this.nonMouSchools.map((school) => ({
          schoolId: school.school.value || school.school,
          teachers: school.teachers
            .map((teacher) => ({
              teacherId: this.extractTeacherId(teacher),
            }))
            .filter((teacher) => !!teacher.teacherId),
        })),
      );
    }

    return allSchools;
  }

  private prepareStep1Payload(type: any): FormData {
    const formData = new FormData();
    const isDraft =
      this.isDraftsubmit === undefined ? true : this.isDraftsubmit === 'Draft';

    if (this.createdEventId || (this.isEdit && this.initialData?.eventId)) {
      formData.append(
        'eventId',
        this.createdEventId || this.initialData?.eventId || '',
      );
    }
    formData.append('saveAsDraft', String(isDraft));
    const eventTypeLabel = this.form.get('eventType')?.value || '';
    formData.append('eventName', eventTypeLabel);
    const eventTypeId = this.form.get('eventName')?.value || '';
    formData.append('eventTypeId', eventTypeId);
    formData.append(
      'description',
      this.form.get('eventDescription')?.value || '',
    );
    const fromDate = this.formatDateToDDMMYYYY(
      this.form.get('fromDate')?.value,
    );
    const toDate = this.formatDateToDDMMYYYY(this.form.get('toDate')?.value);
    if (fromDate) formData.append('eventStartDate', fromDate);
    if (toDate) formData.append('eventEndDate', toDate);
    formData.append(
      'noOfDays',
      (this.form.get('noOfDays')?.value || '0').toString(),
    );
    const eventTimeValue = this.form.get('eventTime')?.value;
    const eventTime = this.formatTimeForSubmission(eventTimeValue);
    if (
      eventTime &&
      eventTime !== '[object Object]' &&
      !eventTime.toString().includes('[object Object]')
    ) {
      formData.append('EventTime', eventTime);
    } else {
      formData.append('EventTime', '');
    }
    formData.append('location', this.form.get('address')?.value || '');
    formData.append('AudienceType', this.form.get('audienceType')?.value || '');
    formData.append(
      'eventHostRegion',
      this.form.get('eventRegion')?.value || '',
    );
    formData.append(
      'mouSchoolsAttending',
      String(this.stepTwoForm.get('isMouSchool')?.value || false),
    );
    formData.append(
      'nonMouSchoolsAttending',
      String(this.stepTwoForm.get('isNonMouSchool')?.value || false),
    );

    const selectedSchools = this.getSelectedSchoolsPayload();
    selectedSchools.forEach((school, schoolIndex) => {
      formData.append(`Schools[${schoolIndex}].SchoolId`, school.schoolId);
      school.teachers.forEach((teacher, teacherIndex) => {
        formData.append(
          `Schools[${schoolIndex}].Teachers[${teacherIndex}].TeacherId`,
          teacher.teacherId,
        );
      });
    });

    const cateringRequiredValue = this.form.get('cateringRequired')?.value;
    if (cateringRequiredValue === 'yes') {
      formData.append('cateringRequired', 'true');
    } else if (cateringRequiredValue === 'no') {
      formData.append('cateringRequired', 'false');
    }
    const busRequiredValue = this.form.get('busRequired')?.value;
    if (busRequiredValue === 'yes') {
      formData.append('busRequired', 'true');
    } else if (busRequiredValue === 'no') {
      formData.append('busRequired', 'false');
    }
    formData.append(
      'additionalRequirements',
      this.form.get('extraRequirements')?.value || '',
    );
    const managerId = this.form.get('eventManager')?.value;
    const disabledManagerId = this.form.get('eventManager')?.value;
    if (managerId || disabledManagerId) {
      formData.append('ManagerIds', managerId || disabledManagerId);
    }

    this.selectedFocusAreaIds.forEach((focusAreaId) => {
      formData.append('FocusAreaIds', focusAreaId);
    });

    if (this.isEdit) {
      const existingImageUrls = this.uploadedImages
        .filter((image) => image.url.startsWith('http'))
        .map((image) => image.url);

      existingImageUrls.forEach((url, index) => {
        formData.append(`ExistingImagePaths[${index}]`, url);
      });

      const newImages = this.uploadedImages.filter(
        (image) => !image.url.startsWith('http'),
      );
      newImages.forEach((image) => {
        formData.append('ImageFiles', image.file);
      });
    } else {
      this.uploadedImages.forEach((image) => {
        formData.append('ImageFiles', image.file);
      });
    }

    return formData;
  }

  private formatTimeForSubmission(timeValue: any): string {
    if (!timeValue) return '';
    if (typeof timeValue === 'string') {
      const timePattern =
        /^\d{1,2}:\d{2}\s*(AM|PM)\s+to\s+\d{1,2}:\d{2}\s*(AM|PM)$/i;
      if (timePattern.test(timeValue)) {
        return timeValue;
      }
    }

    return String(timeValue);
  }

  private formatDateToDDMMYYYY(dateString: string): string {
    if (!dateString) return '';
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();

    return `${year}-${month}-${day}`;
  }

  private prepareStep2Payload(type?: string): Step2Payload {
    const isDraft = type === 'draft';
    const allSchools = this.getSelectedSchoolsPayload();

    const collaborationType = this.getCollaborationType();
    const mccPartnersValue = this.stepTwoForm.get('mccPartners')?.value;
    let mccPartnersArray: { mccPartnerId: string }[] = [];

    if (mccPartnersValue) {
      if (typeof mccPartnersValue === 'string') {
        mccPartnersArray = [{ mccPartnerId: mccPartnersValue }];
      } else if (Array.isArray(mccPartnersValue)) {
        if (
          mccPartnersValue.length > 0 &&
          typeof mccPartnersValue[0] === 'string'
        ) {
          mccPartnersArray = mccPartnersValue.map((partnerId) => ({
            mccPartnerId: partnerId,
          }));
        } else {
          mccPartnersArray = mccPartnersValue;
        }
      }
    }
    const isCsqFundedValue = this.stepTwoForm.get('preTradeOpportunity')?.value;
    const isCsqFunded =
      isCsqFundedValue && isCsqFundedValue !== '' ? isCsqFundedValue : '';
    return {
      eventId: this.createdEventId,
      mouSchoolsAttending: this.stepTwoForm.get('isMouSchool')?.value || false,
      nonMouSchoolsAttending:
        this.stepTwoForm.get('isNonMouSchool')?.value || false,
      nonMouReason: '',
      schools: allSchools,
      careerSeekerOrgsOrSportsClubs: this.stepTwoForm.get(
        'careerSeekerOrganisations',
      )?.value,
      participantsAndSupervisors: this.stepTwoForm.get(
        'approximateParticipants',
      )?.value,
      isCsqFunded: (() => {
        const v = this.stepTwoForm.get('preTradeOpportunity')?.value;
        return v === 'yes' ? true : v === 'no' ? false : null;
      })(),
      collaborating: (() => {
        const v = this.stepTwoForm.get('collaboratingOrganisations')?.value;
        return v === 'yes' ? true : v === 'no' ? false : null;
      })(),
      collaborationType: collaborationType,
      collaboratingWithNonMcc:
        this.stepTwoForm.get('nonMccPartners')?.value || '',
      mccPartners: mccPartnersArray,
      publishNow: type ? false : true,
      saveAsDraft: isDraft,
    };
  }

  private extractTeacherId(teacher: any): string {
    if (!teacher) return '';
    if (typeof teacher === 'string') {
      return teacher;
    }
    if (typeof teacher === 'object') {
      if (teacher.teacherId) return teacher.teacherId;
      if (teacher.userId) return teacher.userId;
      if (teacher.id) return teacher.id;
      if (teacher.value) return teacher.value;
    }

    return String(teacher);
  }

  private getCollaborationType(): number {
    const collaboratingWith = this.stepTwoForm.get('collaboratingWith')?.value;
    switch (collaboratingWith) {
      case COLLABORATION_TYPES.MCC_PARTNERS:
        return 1;
      case COLLABORATION_TYPES.NON_MCC_PARTNERS_ONLY:
        return 2;
      case COLLABORATION_TYPES.MIXTURE:
        return 3;
      default:
        return 0;
    }
  }

  private submitStepOne(type: any, close?: boolean): void {
    if (type !== 'draft') {
      this.isSavedAsDraft = false;
      this.step1SavedAsDraft = false;
    } else {
      this.isSavedAsDraft = true;
      this.step1SavedAsDraft = true;
    }

    // Backdated guard — block past dates unless Super Admin has toggled backdated mode ON
    if (!(this.currentUserRole === 'superadmin' && this.isBackdatedToggle)) {
      const fromDateValue = this.form.get('fromDate')?.value;
      if (fromDateValue) {
        const selectedDate = new Date(fromDateValue);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        selectedDate.setHours(0, 0, 0, 0);
        if (selectedDate < today) {
          this.showErrorToast('Only Super Admin can create backdated events.');
          if (type !== 'draft') this.isProcessing = false;
          else this.isDraftProcessing = false;
          return;
        }
      }
    }

    const formData = this.prepareStep1Payload(type);
    let regionID = this.form.get('eventRegion')?.value;

    this.httpService.post('events/step1', formData, true).subscribe({
      next: (response: any) => {
        if (type === 'draft') {
          this.isDraftProcessing = false;
        } else {
          this.isProcessing = false;
        }

        if (response.status === true || response.success === true) {
          this.storedResponse = response?.data;
          this.createdEventId =
            response.data?.eventId || response.data?.id || response.eventId;
          this.dataSubmitted = true;

          if (regionID) {
            this.originalRegionId = regionID;
            this.fetchMOUSchools(regionID).subscribe();
            this.fetchNONMOUSchools(regionID).subscribe();
          }

          // if (type === 'draft') {
          //     // this.showSuccessToast(response.message || 'Event saved as draft successfully!');
          // } else {
          //     this.showSuccessToast(response.message || 'Event updated successfully!');
          // }

          if (!close) {
            this.stepNext = 2;
          }
          if (close) {
            this.successcall = true;
            this.onCancel();
          }
          this.isRegionChangeConfirmed = false;
          this.regionChangedDuringSubmission = false;
          this.pendingRegionId = null;

          this.form.markAsPristine();
          this.form.markAsUntouched();
          this.form.updateValueAndValidity();
        } else {
          this.showErrorToast(
            response.message || 'Something went wrong. Please try again later.',
          );
        }
      },
      error: (error: any) => {
        if (type === 'draft') {
          this.isDraftProcessing = false;
        } else {
          this.isProcessing = false;
        }

        this.isRegionChangeConfirmed = false;
        this.regionChangedDuringSubmission = false;
        this.pendingRegionId = null;

        if (error.message) {
          this.showErrorToast(error.message);
        } else {
          this.showErrorToast('Something went wrong. Please try again later.');
        }
      },
    });
  }

  getMinEndDate(): string | null {
    const fromDate = this.form.get('fromDate')?.value;
    if (!fromDate) return null;

    const date = new Date(fromDate);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }

  private submitStepTwo(type?: string): void {
    if (!this.createdEventId) {
      this.showErrorToast('Event ID not found. Please complete step 1 first.');
      if (type === 'draft') {
        this.isDraftProcessing = false;
      } else {
        this.isProcessing = false;
      }
      return;
    }

    if (type !== 'draft') {
      this.isSavedAsDraft = false;
    } else {
      this.isSavedAsDraft = true;
      this.successcall = true;
      this.onCancel();
    }

    const payload = this.prepareStep2Payload(type);

    this.httpService.post('events/step2', payload, false).subscribe({
      next: (response: any) => {
        if (type === 'draft') {
          this.isDraftProcessing = false;
        } else {
          this.isProcessing = false;
        }
        if (response.status === true || response.success === true) {
          this.storedResponse = response?.data;
          if (type === 'draft') {
            this.showSuccessToast(
              response.message || 'Event saved as draft successfully!',
            );
            this.successcall = true;
            this.onCancel();
          } else {
            this.showSuccessToast(
              response.message || 'Event published successfully!',
            );
            this.successcall = true;
            this.stepNext = 3;
          }

          this.formSubmitted.emit({
            step1: this.prepareStep1Payload(type),
            step2: payload,
            eventId: this.createdEventId,
          });

          this.isRegionChangeConfirmed = false;
          this.regionChangedDuringSubmission = false;
          this.pendingRegionId = null;

          this.form.markAsPristine();
          this.form.markAsUntouched();
          this.form.updateValueAndValidity();
        } else {
          this.showErrorToast(
            response.message || 'Something went wrong. Please try again later.',
          );
        }
      },
      error: (error: any) => {
        if (type === 'draft') {
          this.isDraftProcessing = false;
        } else {
          this.isProcessing = false;
        }
        this.isRegionChangeConfirmed = false;
        this.regionChangedDuringSubmission = false;
        this.pendingRegionId = null;

        const errorBody = error.error || error;
        const fieldErrors = errorBody?.errors;
        const hasFieldErrors = fieldErrors != null &&
          typeof fieldErrors === 'object' &&
          !Array.isArray(fieldErrors) &&
          Object.values(fieldErrors).some(v => Array.isArray(v));
        if (hasFieldErrors) {
          const messages = (Object.values(fieldErrors) as string[][]).flat().filter(Boolean).join(' ');
          this.showErrorToast(messages || errorBody?.message || 'Something went wrong. Please try again later.');
        } else {
          this.showErrorToast(
            errorBody?.message || error.message || 'Something went wrong. Please try again later.',
          );
        }
      },
    });
  }

  onCancel(type: boolean = true): void {
    if (this.isProcessing) return;

    const hasFormValues = this.hasFormData();

    if (this.dataSubmitted) {
      this.dialogRef.close({ success: true, value: this.storedResponse });
    } else if (this.successcall) {
      this.dialogRef.close({ success: true, value: this.storedResponse });
    }
    // Check if form is dirty OR if there are actual changes (including cleared time fields)
    else if (!this.form.dirty && !this.stepTwoForm.dirty && !hasFormValues) {
      this.dialogRef.close({ success: false });
    } else if (hasFormValues) {
      // Only prompt to save as draft when creating a new event or editing an existing draft.
      // When editing a published (or any non-draft) event, just close without the draft prompt.
      const isDraftContext =
        !this.isEdit ||
        this.isDraftsubmit === undefined ||
        this.isDraftsubmit === 'Draft';

      if (isDraftContext) {
        const dialogData: AlertDialogData = {
          title: '',
          message: `Do you want to save this draft?`,
          okText: 'Save',
          cancelText: 'Cancel',
          icon: 'warning',
          submessage: '',
          cancelButtonColor: '#EF4A00',
          okButtonColor: '#2CC3E8',
        };

        const dialogRef = this.dialog.open(AlertDialogComponent, {
          width: '25.438rem',
          data: dialogData,
        });

        dialogRef.afterClosed().subscribe((result) => {
          if (result) {
            this.onSubmit('draft', true);
          } else {
            this.dialogRef.close({ success: false });
          }
        });
      } else {
        this.dialogRef.close({ success: false });
      }
    } else {
      this.dialogRef.close({ success: false });
    }
  }

  private hasFormData(): any {
    // Check if time values have changed
    if (this.hasTimeValueChanged()) {
      return true;
    }

    const step1HasData = Object.keys(this.form.controls).some((key) => {
      const control = this.form.get(key);
      const currentValue = control?.value;
      const initialValue = this.initialFormValues?.form?.[key];

      // Skip comparison for eventTime as we already checked it
      if (key === 'eventTime') {
        return false;
      }

      // Handle special cases
      if (key === 'cateringRequired' || key === 'busRequired') {
        // Check if value changed from initial
        return currentValue !== initialValue;
      }

      // For other fields, check if they have values or changed
      if (
        key === 'eventName' ||
        key === 'eventType' ||
        key === 'eventManager' ||
        key === 'fromDate' ||
        key === 'toDate' ||
        key === 'address' ||
        key === 'audienceType' ||
        key === 'eventRegion' ||
        key === 'extraRequirements'
      ) {
        // Check if current value exists and is different from initial
        const hasCurrentValue =
          currentValue && currentValue.toString().trim() !== '';
        const hasInitialValue =
          initialValue && initialValue.toString().trim() !== '';

        if (hasCurrentValue !== hasInitialValue) return true;
        if (
          hasCurrentValue &&
          currentValue.toString().trim() !== initialValue.toString().trim()
        )
          return true;
      }

      return false;
    });

    const step2HasData = Object.keys(this.stepTwoForm.controls).some((key) => {
      const control = this.stepTwoForm.get(key);
      const currentValue = control?.value;
      const initialValue = this.initialFormValues?.stepTwoForm?.[key];

      if (key === 'isMouSchool' || key === 'isNonMouSchool') {
        return currentValue !== initialValue;
      }

      const hasCurrentValue =
        currentValue && currentValue.toString().trim() !== '';
      const hasInitialValue =
        initialValue && initialValue.toString().trim() !== '';

      if (hasCurrentValue !== hasInitialValue) return true;
      if (
        hasCurrentValue &&
        currentValue.toString().trim() !== initialValue.toString().trim()
      )
        return true;

      return false;
    });

    const hasFocusAreasChanged =
      JSON.stringify(this.selectedFocusAreaIds) !==
      JSON.stringify(this.initialFormValues?.selectedFocusAreaIds || []);

    const hasImagesChanged =
      JSON.stringify(this.uploadedImages.map((img) => img.url)) !==
      JSON.stringify(
        this.initialFormValues?.uploadedImages?.map(
          (img: { url: any }) => img.url,
        ) || [],
      );

    const hasMouSchoolsChanged =
      JSON.stringify(
        this.mouSchools.map((s) => ({
          school: s.school,
          teachers: s.teachers.map((t) => t.teacherId || t.userId || t.value),
        })),
      ) !==
      JSON.stringify(
        this.initialFormValues?.mouSchools?.map(
          (s: {
            school: any;
            teachers: { teacherId: any; userId: any; value: any }[];
          }) => ({
            school: s.school,
            teachers: s.teachers.map(
              (t: { teacherId: any; userId: any; value: any }) =>
                t.teacherId || t.userId || t.value,
            ),
          }),
        ) || [],
      );

    const hasNonMouSchoolsChanged =
      JSON.stringify(
        this.nonMouSchools.map((s) => ({
          school: s.school,
          teachers: s.teachers.map((t) => t.teacherId || t.userId || t.value),
        })),
      ) !==
      JSON.stringify(
        this.initialFormValues?.nonMouSchools?.map(
          (s: {
            school: any;
            teachers: { teacherId: any; userId: any; value: any }[];
          }) => ({
            school: s.school,
            teachers: s.teachers.map(
              (t: { teacherId: any; userId: any; value: any }) =>
                t.teacherId || t.userId || t.value,
            ),
          }),
        ) || [],
      );

    const hasNoteTextChanged =
      this.noteText !== this.initialFormValues?.noteText;
    const hasAddressTextChanged =
      this.addressText !== this.initialFormValues?.addressText;

    return (
      step1HasData ||
      step2HasData ||
      hasFocusAreasChanged ||
      hasImagesChanged ||
      hasMouSchoolsChanged ||
      hasNonMouSchoolsChanged ||
      hasNoteTextChanged ||
      hasAddressTextChanged
    );
  }

  private showSuccessToast(message: string): void {
    this.snackBar.openFromComponent(CustomToastComponent, {
      data: { message },
      duration: 3000,
      horizontalPosition: 'right',
      verticalPosition: 'top',
      panelClass: ['no-padding-snackbar', 'success-toast'],
    });
  }

  private showErrorToast(
    message: string | null | undefined,
    duration: number = 3000,
  ): void {
    if (!message) return;
    this.snackBar.openFromComponent(CustomToastComponent, {
      data: { message },
      duration: duration ? duration : 3000,
      horizontalPosition: 'right',
      verticalPosition: 'top',
      panelClass: ['no-padding-snackbar', 'error-toast'],
    });
  }

  autoResize(event: Event): void {
    const textarea = event.target as HTMLTextAreaElement;
    textarea.style.height = 'auto';
    textarea.style.height = `${textarea.scrollHeight}px`;
  }

  calculateDays(): void {
    const fromDate = this.form.get('fromDate')?.value;
    const toDate = this.form.get('toDate')?.value;

    if (fromDate && toDate) {
      const start = new Date(fromDate);
      const end = new Date(toDate);

      if (end < start) {
        this.form.get('noOfDays')?.setValue('');
        return;
      }
      let count = 0;
      const current = new Date(start);
      while (current <= end) {
        const dayOfWeek = current.getDay();
        if (dayOfWeek !== 0 && dayOfWeek !== 6) {
          count++;
        }
        current.setDate(current.getDate() + 1);
      }

      this.form.get('noOfDays')?.setValue(count);
    } else {
      this.form.get('noOfDays')?.setValue('');
    }
  }

  validateDates(): void {
    const fromDate = this.form.get('fromDate')?.value;
    const toDate = this.form.get('toDate')?.value;
    const fromDateControl = this.form.get('fromDate');
    const toDateControl = this.form.get('toDate');

    const setError = (
      control: AbstractControl | null,
      errorKey: string,
      shouldSet: boolean,
      message?: string,
    ) => {
      if (!control) return;

      const currentErrors = { ...(control.errors || {}) };

      if (shouldSet) {
        currentErrors[errorKey] = message || true;
        control.setErrors(currentErrors);
      } else if (currentErrors[errorKey]) {
        delete currentErrors[errorKey];
        control.setErrors(Object.keys(currentErrors).length ? currentErrors : null);
      }
    };

    if (fromDate && toDate) {
      const start = new Date(fromDate);
      const end = new Date(toDate);

      const isStartWeekend =
        start.getDay() === 0 || start.getDay() === 6;
      const isEndWeekend = end.getDay() === 0 || end.getDay() === 6;

      setError(
        fromDateControl,
        'weekend',
        isStartWeekend,
        'Weekends are not available for event scheduling.',
      );
      setError(
        toDateControl,
        'weekend',
        isEndWeekend,
        'Weekends are not available for event scheduling.',
      );

      if (isStartWeekend || isEndWeekend) {
        this.form.get('noOfDays')?.setValue('');
        return;
      }

      if (end < start) {
        setError(
          toDateControl,
          'dateRange',
          true,
          'End date must be after start date',
        );
        this.form.get('noOfDays')?.setValue('');
      } else {
        setError(toDateControl, 'dateRange', false);
        this.calculateDays();
      }
    } else if (fromDate) {
      const start = new Date(fromDate);
      const isStartWeekend =
        start.getDay() === 0 || start.getDay() === 6;

      setError(
        fromDateControl,
        'weekend',
        isStartWeekend,
        'Weekends are not available for event scheduling.',
      );

      if (isStartWeekend) {
        this.form.get('noOfDays')?.setValue('');
        return;
      }

      this.calculateDays();
    } else {
      setError(fromDateControl, 'weekend', false);
      setError(toDateControl, 'weekend', false);
      setError(toDateControl, 'dateRange', false);
    }
  }

  onBackdatedToggleChange(): void {
    this.minDateValue = this.getMinDate();
    if (!this.isBackdatedToggle) {
      this.form.get('fromDate')?.setValue('');
      this.form.get('toDate')?.setValue('');
    }
  }

  getMinDate(): string | null {
    if (this.currentUserRole === 'superadmin' && this.isBackdatedToggle) return null;
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
}
